'use strict';
import {observeOnAttributes} from '../../core-utilities/rx-utils';
import {icons} from './icons';
import {getIcon} from './file-icons';

svgIconDirective.DIRECTIVE_NAME = 'svgIcon';

export function svgIconDirective() {
  return {
    link: link,
    restrict: 'E',
  };

  function link(scope, element, attrs) {
    function path(icon, isFile) {
      return `<svg viewBox="0 0 1024 1024"><title>${icon}</title>${isFile ? getIcon(icon) : icons[icon]}</svg>`;
    }

    function renderSVG() {
      element.html(path(attrs.p, attrs.file));
    }

    renderSVG();

    observeOnAttributes(attrs, 'p')
      .distinctUntilChanged()
      .subscribe(icon => {
        element.html(path(icon, attrs.file));
      });
  }

}



// WEBPACK FOOTER //
// ./src/js/core-components/svg-menu-icons/svgIconDirective.js